/** Normalize DRF / API error payloads into a single user-facing string. */
export function parseApiErrorMessage(data, fallback = "Something went wrong") {
  if (!data) {
    return fallback
  }
  if (typeof data === "string") {
    return data
  }
  if (typeof data.detail === "string") {
    return data.detail
  }
  if (
    Array.isArray(data.non_field_errors) &&
    data.non_field_errors.length > 0
  ) {
    return data.non_field_errors[0]
  }
  if (typeof data.non_field_errors === "string") {
    return data.non_field_errors
  }

  for (const value of Object.values(data)) {
    if (typeof value === "string") {
      return value
    }
    if (
      Array.isArray(value) &&
      value.length > 0 &&
      typeof value[0] === "string"
    ) {
      return value[0]
    }
  }

  return fallback
}
